export function shouldMountStudioTour(pathname: string): boolean {
  return !pathname.startsWith("/public/");
}

// Option-2 anonymous attend surface: the CD attendee SPA is served on the
// `attend.<tenant>` host at the bare `/<slug>` path (NOT under `/public/`), so
// host — not just pathname — decides whether a hit is a public attendee route.
// This is host-guarded to the literal first DNS label `attend`, making it a
// strict NO-OP on `studio.<tenant>` (whose first label is never `attend`).
export function isAttendHost(hostname: string): boolean {
  return (hostname.split(".")[0] ?? "").toLowerCase() === "attend";
}
